import { render, staticRenderFns } from "./WPrice.vue?vue&type=template&id=3796b65d&scoped=true&"
import script from "./WPrice.vue?vue&type=script&lang=js&"
export * from "./WPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796b65d",
  null
  
)

export default component.exports